import { render, staticRenderFns } from "./template.html?vue&type=template&id=507e250b&scoped=true&external"
import script from "./PoleTouroku.vue?vue&type=script&lang=js"
export * from "./PoleTouroku.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=507e250b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507e250b",
  null
  
)

export default component.exports